import React, { createContext, useState, useContext } from "react";
import { ChatContextType, Chat } from "../types/interfaces";
import services from "../services";
import { useAuth } from "@clerk/clerk-react";

const ChatContext = createContext<ChatContextType>({} as ChatContextType);

export const ChatProvider: React.FC<any> = ({ children }) => {
	const [chats, setChats] = useState<Chat[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const { getToken } = useAuth();

	const addChat = (chat: Chat) => {
		setChats((prevChats) => [...prevChats, chat]);
	};

	const sendChat = async (prompt: string) => {
		setIsLoading(true);
		try {
			const token = await getToken();
			// Assuming the updated services.chatService.newQuestion to return an object with text and audioUrl
			const { textResponse, audioUrl } = await services.chatService.newQuestion(
				prompt,
				token,
			);
			const newChat: Chat = {
				text: textResponse,
				isResponse: true,
				audioUrl: audioUrl, // Include the audio URL in the chat object
			};
			addChat(newChat);
		} catch (error) {
			console.error("Error sending chat:", error);
			// Optionally handle the error by adding an error message to the chat
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<ChatContext.Provider value={{ chats, addChat, sendChat, isLoading }}>
			{children}
		</ChatContext.Provider>
	);
};

export const useChat = () => useContext(ChatContext);

export default ChatProvider;
